import { AppConfig } from '../appConfig';

const configStg: AppConfig = {
  env: 'stg',
  url: {
    userWeb: `https://d99jysqyih3mz.cloudfront.net`,
    customerWeb: `https://d6p7f3s09k0v4.cloudfront.net`,
  },
  apiGateway: {
    region: 'ap-northeast-1',
    endpoint: `https://7i15tun5cj.execute-api.ap-northeast-1.amazonaws.com/stg`,
  },
  s3: {
    region: 'ap-northeast-1',
    bucket: {
      staticContents: {
        name: `branq-${process.env.REACT_APP_STAGE}-static-contents`,
        endpoint: `https://d19kf18flo5u4m.cloudfront.net`,
      },
      upload: {
        name: `branq-${process.env.REACT_APP_STAGE}-upload`,
      },
    },
  },
  ses: {
    from: {
      address: 'no-reply@branq.jp',
    },
  },
  cognito: {
    region: 'ap-northeast-1',
    userPoolId: 'ap-northeast-1_7IgFMZDNt',
    clientId: '4hi7kgpn1mjkcu9umkhntk03vl',
    identityPoolId: 'ap-northeast-1:be571e78-4d12-4225-abd9-263427c50e3b',
  },
};

export default configStg;
